const ROLE_ALLOWED_PREFIXES = {
    superadmin: [
        "/",
        "/staff",
        "/groups",
        "/group",
        "/hr/admins",
        "/analytics",
        "/catalog",
        "/my-orders",
        "/orders",
        "/personal",
        "/my-development",
        "/diary",
        "/mood/tracker",
        "/library",
        "/subscription",
        "/faq",
        "/profile",
        "/relations",
        "/rating",
        "/detailed",
        "/instruments",
        "/courses",
    ],
    admin: [
        "/",
        "/staff",
        "/groups",
        "/group",
        "/hr/admins",
        "/analytics",
        "/catalog",
        "/my-orders",
        "/orders",
        "/personal",
        "/my-development",
        "/diary",
        "/mood/tracker",
        "/library",
        "/subscription",
        "/faq",
        "/profile",
        "/relations",
        "/rating",
        "/detailed",
        "/instruments",
        "/courses",
    ],
    hr_department: [
        "/",
        "/staff",
        "/groups",
        "/group",
        "/analytics",
        "/catalog",
        "/my-orders",
        "/orders",
        "/personal",
        "/my-development",
        "/diary",
        "/mood/tracker",
        "/library",
        "/faq",
        "/profile",
        "/rating",
        "/detailed",
        "/instruments",
        "/courses",
    ],
    staff: [
        "/personal",
        "/my-development",
        "/diary",
        "/mood/tracker",
        "/library",
        "/faq",
        "/profile",
        "/instruments",
        "/courses",
    ],
    private_person: [
        "/personal",
        "/my-development",
        "/diary",
        "/mood/tracker",
        "/library",
        "/faq",
        "/profile",
        "/instruments",
        "/courses",
        "/subscription",
    ],
};

const SUBSCRIPTION_GATED_PREFIXES = [
    "/analytics/dashboard",
    "/analytics/reports",
    "/my-development",
    "/diary",
    "/mood/tracker",
    "/library/list",
    "/instruments",
    "/courses",
];

const normalizePath = (route) => (route || "/").split("?")[0];

const startsWithAny = (path, prefixes) =>
    prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`) || path.startsWith(prefix));

export const canAccessProhorRoute = ({ route, role, hasSubscription }) => {
    const path = normalizePath(route);
    if (!role || !path) return false;

    const allowedPrefixes = ROLE_ALLOWED_PREFIXES[role] || [];
    if (!startsWithAny(path, allowedPrefixes)) return false;

    const requiresSubscription = startsWithAny(path, SUBSCRIPTION_GATED_PREFIXES);
    if (requiresSubscription && !hasSubscription) return false;

    return true;
};

export const filterProhorActionsByAccess = ({
    actions,
    role,
    hasSubscription,
}) => {
    if (!Array.isArray(actions)) return [];

    return actions.filter((action) =>
        canAccessProhorRoute({
            route: action?.route,
            role,
            hasSubscription,
        })
    );
};
